import React from "react";
import axios from "axios";
import configureStore from "../redux";
import { getCookie } from "../services/cookie";
import { detectMobile } from "../services/utils";
import CookieService from "../services/CookieService";

const isServer = typeof window === "undefined";
const __NEXT_REDUX_STORE__ = "__NEXT_REDUX_STORE__";

function getOrCreateStore(initialState) {
  // Always make a new store if server, otherwise state is shared between requests
  if (isServer) {
    return configureStore(initialState);
  }

  // Create store if unavailable on the client and set it on the window object
  if (!window[__NEXT_REDUX_STORE__]) {
    window[__NEXT_REDUX_STORE__] = configureStore(initialState);
  }
  return window[__NEXT_REDUX_STORE__];
}

export default App => {
  return class AppWithRedux extends React.Component {
    static async getInitialProps(appContext) {
      // Get or Create the store with `undefined` as initialState
      // This allows you to set a custom default initialState
      const reduxStore = getOrCreateStore();

      // Provide the store to getInitialProps of pages
      appContext.ctx.reduxStore = reduxStore;

      let appProps = {};
      if (typeof App.getInitialProps === "function") {
        appProps = await App.getInitialProps(appContext);
      }

      const { req } = appContext.ctx;

      const initialReduxState = reduxStore.getState();

      let recDeviceId = getCookie("recDeviceId", req) || "";
      const isNativeApp = CookieService.getCookie("is_native_app", req) || "";

      if (req && req.recDeviceId) {
        recDeviceId = req.recDeviceId;
      }

      if (!req && !recDeviceId) {
        // running on browser create clientId
        try {
          let url = `${process.env.REC_URL}/v1/deviceid`;

          url += `?from=${window.location.href}`;

          const response = await axios.get(url);
          // for testing remove later
          console.log(
            "recruiter deviceID created on client side",
            response.data
          );
          recDeviceId = response.data.data.recDeviceId;
        } catch (err) {
          console.log(err);
        }
      }

      initialReduxState.commonReducer = {
        ...initialReduxState.commonReducer,
        recDeviceId,
        isNativeApp
      };

      if (req) {
        initialReduxState.commonReducer = {
          ...initialReduxState.commonReducer,
          deviceType: req.isMobile ? "mobile" : "desktop"
        };
      } else {
        initialReduxState.commonReducer = {
          ...initialReduxState.commonReducer,
          deviceType: detectMobile() ? "mobile" : "desktop"
        };
      }

      return {
        ...appProps,
        initialReduxState: initialReduxState
      };
    }

    constructor(props) {
      super(props);
      this.reduxStore = getOrCreateStore(props.initialReduxState);
    }

    render() {
      return <App {...this.props} reduxStore={this.reduxStore} />;
    }
  };
};
